import type { BranchStatus } from '../enums/BranchStatus'

export class BranchStatusLogEntity {
  status?: BranchStatus
  reason?: string | null
  userId?: string
  userDisplayName?: string | null
  dateTime?: string
}
